module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Få bedre<br> hukommelse","label":"Praksis"},"en":{"title":"Improve<br> your memory","label":"Practice"}}')
  delete Component.options._Ctor
}
